import {BrowserRouter, Routes, Route ,useLocation, Navigate } from 'react-router-dom'
import SignUp from './pages/Signup'
import HomePage from './Home'
import Login from './pages/Login'
import ContactUs from './pages/Contact'
import Dashboard from './pages/Dashboard'
import SupportPage from './pages/Support'
import Practice from './pages/Practice'
import PracticeQuestionListPage from './pages/PracticeQuestionListPage'
import PracticeMicrophoneGate from './pages/PracticeMicrophoneGate'
import { useEffect, useRef } from "react";
import { useState } from "react";
import Openquestion from './pages/openquestion'
import PrivateRoutes from './AuthRoutes/PrivateRoutes'
import Checkout from './Checkout/checkout'
import AdminPanel from './Admin/admin'
import AdminOnboardingAnalyticsPage from './Admin/AdminOnboardingAnalyticsPage'
import AdminThemeLayout from './Admin/appearance/AdminThemeLayout'
import AdminPersonalisationPage from './Admin/AdminPersonalisationPage'
import Adminpractice from './Admin/Components/QuestionsPage/AdminQuestionPage'
import Adminreadaloud from './Admin/Components/adminreadaloud'
import Unauthorized  from './pages/unauthorized'
import Billing from './pages/billing'
import SamplePage from './pages/QuestionPage/Page'
import DescribeImagePage from './pages/QuestionPage/DescribeImagePage'
import RepeatSentencePage from './pages/QuestionPage/RepeatSentencePage'
import SummerizeTextPage from './pages/QuestionPage/SummarizeTextPage'
import MultiSelectPage from './pages/QuestionPage/MultiSelectPage'
import RetellLecturePage from './pages/Re-tell-LecturePage'
import AnswerShortQuestionPage from './pages/QuestionPage/AnswerShortQuestionPage'
import WriteEssayPage from './pages/QuestionPage/WriteEssayPage'
import MultiTypeSingleAnswerPage from './pages/QuestionPage/MultiTypeSingleAnswerPage'
import MultipleDoubleAnswerPage from './pages/QuestionPage/MultipleDoubleAnswerPage'
import ReOrderParagraphPage from './pages/QuestionPage/ReOrderParagraphPage'
import ReadingFillInTheBlanksPage from './pages/QuestionPage/ReadingFillInTheBlanksPage'
import FillInTheBlanksReadingAndWritingPage from './pages/QuestionPage/FillInTheBlanksReadingAndWritingPage'
import SummarizeSpokenTextPage from './pages/QuestionPage/SummarizeSpokenTextPage'
import McqSingleAnswerPage from './pages/QuestionPage/McqSingleAnswerPage'
import McqMultipleAnswersPage from './pages/QuestionPage/McqMultipleAnswerPage'
import FillInTheBlanksListeningPage from './pages/QuestionPage/FillInTheBlankListeningPage'
import HighlightCorrecctSummaryPage from './pages/QuestionPage/HighlightCorrectSummaryPage'
import SelectMissingWordsPage from './pages/QuestionPage/SelectMissingWordsPage'
import WriteFromDictationPage from './pages/QuestionPage/WriteFromDictationPage'
import HighlightIncorrectWordPage from './pages/QuestionPage/HighlightIncorrectWordPage'
import MockTestPage from './pages/MockTest/MockTestSpeakingPage'
import MockTestWritingPage from './pages/MockTest/MockTestWritingPage'
import MockTestReadingPage from './pages/MockTest/MockTestReadingPage'
import MockTestListeningPage from './pages/MockTest/MockTestListeningPage'
import MockTestFullTestPage from './pages/MockTest/MockTestFullTestPage'
import MockPage from './pages/MockTest/Mock'
import FullMockTestPage from './pages/MockTest/FullMockTestPage'
import SurveyPage from './pages/Survey/SurveyPage'
import Success from './StatusPages/PaymentSuccess'
import AccountPage from './Account/AccountPage'
import UpgradeYourPlan from './StatusPages/UpgradeyourPlan'
import BillingCheckout from './Checkout/BillingCheckout'
import ResultPage from './pages/MockTest/Result'
import ResultNavigation from './pages/MockTest/ResultNavigation'
import SpeakingMockTestPage from './pages/MockTest/MockTestSpeakingPage'
import MockPagination from './pages/MockTest/Pagination'
import User from './Admin/Components/UserPage/User'
import Post from './Admin/Components/Post'
import EditQuestionForm from './Admin/Components/QuestionsPage/AdminEditQuestionForm'
import ForgotPassword from './Account/ForgotPasswordPage'
import ResetPassword from './Account/ResetPasswordPage'
import VerifyEmailPage from './Account/VerifyEmailPage'
import BlogHomePage from './Blog/Blog'
import BlogPostPage from './Blog/Post/Post'
import LatestPostsPage from './Blog/LatestPostsPage'
import ProductAdmin from './Admin/Components/Settings/ProductAdmin'
import DynamicPricingAdminPage from './Admin/Components/Settings/AdminDynamicPricing'
import PricingPage from './components/PricingPage'
import { initGA, logPageView } from "./analytics";
import SummarizeGroupDiscussionPage from './pages/SummarizeGroupDiscussionPage'
import RespondToSituationPage from './pages/RespondToSituationPage'
import SpeakingMockResultPage from './pages/SpeakingMockResultPage'
import WritingMockResultPage from './pages/WritingMockResultPage'
import ReadingMockResultPage from './pages/ReadingMockResultPage'
import ListeningMockResultPage from './pages/ListeningMockResultPage'
import { captureFirstTouchAttribution } from './attribution'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import toastify CSS


// Track route views once, including during React StrictMode's effect replay.
const TrackSelectedPages = () => {
    const location = useLocation();
    const lastView = useRef(null);
  
    useEffect(() => {
      const view = `${location.key}:${location.pathname}`;
      if (lastView.current === view) return;
      lastView.current = view;
      logPageView(location.pathname);
    }, [location]);
  
    return null;
  };
  
export default function App(){

    const [backendData, setBackendData] = useState([{}])
    
    
    useEffect(() => {

        initGA();
        captureFirstTouchAttribution();

        fetch("/api").then(
            response => response.json().then(
                data => {
                    setBackendData(data)
                }
            )

        )

        
    }, [])

 

    return(
        
        <div>
     
     <ToastContainer />

            <BrowserRouter>
            <TrackSelectedPages /> 
                <Routes>
                    <Route index element={<HomePage />} />
                    <Route path="/signup" element ={<SignUp/>}/>
                    <Route path="/login" element ={<Login/>}/>
                    <Route path="/contact" element ={<ContactUs/>}/>
                    <Route path="/checkout" element ={<Checkout/>}/>
                    <Route path="/survey" element ={<SurveyPage/>}/>
                    <Route path="/success" element ={<Success/>}/>
                    <Route path="/unauthorized" element ={<Unauthorized/>}/>
                    <Route path="/forgotpassword" element ={<ForgotPassword/>}/>
                    <Route path="/reset-password/:token" element ={<ResetPassword/>}/>
                    <Route path="/verify-email/" element ={<VerifyEmailPage/>}/>
                    <Route path="/blog" element ={<BlogHomePage/>}/>
                    <Route path="/blog/latest/" element ={<LatestPostsPage/>}/>
                    <Route path="/blogs" element={<Navigate to="/blog" replace />} />
                    <Route path="/blogs/latest" element={<Navigate to="/blog/latest/" replace />} />
                    <Route path="/blog/:link" element ={<BlogPostPage/>}/>
                    <Route path="/pricing" element ={<PricingPage/>}/>
                    <Route path="/onboarding" element={<Navigate to="/dashboard" replace />} />
                 
                    {/* Premium User Routes [Role Code-4] */}

                    <Route element={<PrivateRoutes allowedRoles={[1,4,5,6]} />}>
                        
                        <Route path="/page" element ={<SamplePage/>}/>
                      
                        {/* <Route path="/mocktest/" element ={<MockTestPage/>}/> */}
                        <Route path="/mockpage/" element ={<MockPage/>}/>
                        <Route path="/mockpage/result" element ={<MockPagination/>}/>
                        <Route path="/mockpage/speakingresult" element ={<SpeakingMockResultPage/>}/>
                        <Route path="/mockpage/writingresult" element ={<WritingMockResultPage/>}/>
                        <Route path="/mockpage/readingresult" element ={<ReadingMockResultPage/>}/>
                        <Route path="/mockpage/listeningresult" element ={<ListeningMockResultPage/>}/>
                        <Route path="/mockpage/result/:id" element ={<ResultPage/>}/>
                        <Route path="/mockpage/fullmocktest" element ={<FullMockTestPage/>}/>
                        <Route path="/mockpage/writingmocktest" element ={<MockTestWritingPage/>}/>
                        <Route path="/mockpage/readingmocktest" element ={<MockTestReadingPage/>}/>
                        <Route path="/mockpage/listeningmocktest" element ={<MockTestListeningPage/>}/>
                        <Route path="/mockpage/speakingmocktest" element ={<SpeakingMockTestPage/>}/>
                        <Route path="/mocktest/fullmocktest" element ={<MockTestFullTestPage/>}/>
                        <Route path="/text" element ={<SummerizeTextPage/>}/>
                        <Route path="/multi" element ={<MultiSelectPage/>}/>
                       

                    </Route>


                    {/* Starter User Routes [Role Code-5]*/}

                    {/* Basic User Routes [Role Code-6]*/}

                    
                    {/* User With Expired or No Subscription [Role Code-7] */}

                    <Route element={<PrivateRoutes allowedRoles={[1,4,5,6,7]} />}>
                        <Route path="/dashboard" element ={<Dashboard/>}/>
                        <Route path="/billing" element ={<Billing/>}/>
                        <Route path="/billingcheckout" element ={<BillingCheckout/>}/>
                        <Route path="/upgradeplan" element ={<UpgradeYourPlan/>}/>
                        <Route path="/account" element ={<AccountPage/>}/>

                        <Route path="/practice" element ={<Practice/>}/>
                        <Route path="/practice/readaloud" element ={<PracticeQuestionListPage heading="Read Aloud" questionTitle="readaloud" />}/>
                        <Route element={<PracticeMicrophoneGate />}>
                        <Route path="/practice/describeimage/:title/" element ={<DescribeImagePage/>}/>
                        <Route path="/practice/repeatsentence/:title" element ={<RepeatSentencePage/>}/>
                        <Route path="/practice/retelllecture/:title" element ={<RetellLecturePage/>}/>
                        <Route path="/practice/answershortquestions/:title" element ={<AnswerShortQuestionPage/>}/>
                        <Route path="/practice/summarizegroupdiscussion/:title" element ={<SummarizeGroupDiscussionPage/>}/>
                        <Route path="/practice/respondtosituation/:title" element ={<RespondToSituationPage/>}/>

                        <Route path="/practice/summarizewrittentext/:title" element ={<SummerizeTextPage/>}/>
                        <Route path="/practice/writeessay/:title" element ={<WriteEssayPage/>}/>
                        <Route path="/practice/multipletypesingleanswer/:title" element ={<MultiTypeSingleAnswerPage/>}/>
                        <Route path="/practice/multipletypedoubleanswer/:title" element ={<MultipleDoubleAnswerPage/>}/>
                        <Route path="/practice/reorderparagraph/:title" element ={<ReOrderParagraphPage/>}/>
                        <Route path="/practice/readingfillintheblanks/:title" element ={<ReadingFillInTheBlanksPage/>}/>
                        <Route path="/practice/fillintheblanksreadingandwriting/:title" element ={<FillInTheBlanksReadingAndWritingPage/>}/>
                        <Route path="/practice/summarizespokentext/:title" element ={<SummarizeSpokenTextPage/>}/>
                        <Route path="/practice/mcqsingleanswer/:title" element ={<McqSingleAnswerPage/>}/>
                        <Route path="/practice/mcqmultipleanswer/:title" element ={<McqMultipleAnswersPage/>}/>
                        <Route path="/practice/fillintheblanks/:title" element ={<FillInTheBlanksListeningPage/>}/>
                        <Route path="/practice/highlightcorrectsummary/:title" element ={<HighlightCorrecctSummaryPage/>}/>
                        <Route path="/practice/selectmissingwords/:title" element ={<SelectMissingWordsPage/>}/>
                        <Route path="/practice/writefromdictation/:title" element ={<WriteFromDictationPage/>}/>
                        <Route path="/practice/hightlightincorrectwords/:title" element ={<HighlightIncorrectWordPage/>}/>
                        <Route path="/practice/:section/:title" element ={<Openquestion/>}/>
                        </Route>
                        <Route path="/practice/repeatsentence" element ={<PracticeQuestionListPage heading="Repeat Sentence" questionTitle="repeatsentence" />}/>
                        <Route path="/practice/describeimage" element ={<PracticeQuestionListPage heading="Describe Image" questionTitle="describeimage" />}/>
                        <Route path="/practice/re-tell-lectures" element ={<PracticeQuestionListPage heading="Re Tell Lecture" questionTitle="retelllecture" />}/>
                        <Route path="/practice/shortquestions" element ={<PracticeQuestionListPage heading="Answer Short Questions" questionTitle="answershortquestion" />}/>
                        <Route path="/practice/summarizegroupdiscussion" element ={<PracticeQuestionListPage heading="Summarize Group Discussion" questionTitle="summarizegroupdiscussion" />}/>
                        <Route path="/practice/respondtosituation" element ={<PracticeQuestionListPage heading="Respond to Situation" questionTitle="respondtosituation" />}/>
                        <Route path="/practice/summarize-written-text" element ={<PracticeQuestionListPage heading="Summarize Written Text" questionTitle="summarizetext" />}/>
                        <Route path="/practice/write-essay" element ={<PracticeQuestionListPage heading="Write Essay" questionTitle="writeessay" />}/>
                        <Route path="/practice/reading-zone/single-answer" element ={<PracticeQuestionListPage heading="Multiple Type Single Answer" questionTitle="singleanswer" />}/>
                        <Route path="/practice/reading-zone/double-answer" element ={<PracticeQuestionListPage heading="Multiple Type Double Answer" questionTitle="doubleanswer" />}/>
                        <Route path="/practice/reading-zone/re-order-paragraph" element ={<PracticeQuestionListPage heading="ReOrder Paragraph" questionTitle="reorderparagraph" />}/>
                        <Route path="/practice/reading-zone/fill-in-the-blanks" element ={<PracticeQuestionListPage heading="Reading Fill in the Blanks" questionTitle="fillintheblank" />}/>
                        <Route path="/practice/reading-zone/reading-and-writing" element ={<PracticeQuestionListPage heading="Fill In The Blanks Reading And Writing" questionTitle="readingandwriting" />}/>
                        <Route path="/practice/listening-zone/summarize-spoken-text" element ={<PracticeQuestionListPage heading="Summarize Spoken Text" questionTitle="summarizespokentext" />}/>
                        <Route path="/practice/listening-zone/mcq-single-answer" element ={<PracticeQuestionListPage heading="MCQ Single Answer" questionTitle="mcqsingleanswer" />}/>
                        <Route path="/practice/listening-zone/mcq-double-answer" element ={<PracticeQuestionListPage heading="MCQ Multiple Answer" questionTitle="mcqdoubleanswer" />}/>
                        <Route path="/practice/listening-zone/fill-blanks" element ={<PracticeQuestionListPage heading="Fill In The Blanks" questionTitle="fillblank" />}/>
                        <Route path="/practice/listening-zone/highlight-correct-summary" element ={<PracticeQuestionListPage heading="Highlight Correct Summary" questionTitle="highlightsummary" />}/>
                        <Route path="/practice/listening-zone/select-missing-words" element ={<PracticeQuestionListPage heading="Select Missing Words" questionTitle="missingword" />}/>
                        <Route path="/practice/listening-zone/hightlight-incorrect-words" element ={<PracticeQuestionListPage heading="Hightlight Incorrect Words" questionTitle="incorrectword" />}/>
                        <Route path="/practice/listening-zone/write-from-dictation" element ={<PracticeQuestionListPage heading="Write From Dictation" questionTitle="writefromdictation" />}/>


                    </Route>

                    <Route element={<PrivateRoutes allowedRoles={[1,2,3,4,5,6]} />}>
                        <Route path="/support" element ={<SupportPage/>}/>
                    </Route>

                    {/* Admin Routes  */}
                    <Route element={<AdminThemeLayout />}>
                    <Route element={<PrivateRoutes allowedRoles={[1,2]} />}>

                        <Route path="/admin" element ={<AdminPanel/>}/>
                        <Route path="/admin/personalisation" element={<AdminPersonalisationPage />} />
                        <Route path="/admin/user" element ={<User/>}/>
                        <Route path="/admin/product" element ={<ProductAdmin/>}/>
                        <Route path="/admin/product/:price" element ={<DynamicPricingAdminPage/>}/>
                        <Route path="/admin/post" element ={<Post/>}/>
                        <Route path="/admin/practice" element ={<Adminpractice/>}/>
                        <Route path="/admin/practice/edit/:id" element ={<EditQuestionForm/>}/>

                    </Route>

                    <Route element={<PrivateRoutes allowedRoles={[1]} deniedRedirect="/unauthorized" />}>
                        <Route path="/admin/onboarding-analytics" element={<AdminOnboardingAnalyticsPage />} />
                    </Route>
                    </Route>

                    {/* Manager Routes [Role Code-2 ] */}

                    {/* Employee Routes [Role Code-3 ] */}

                


                </Routes>
            </BrowserRouter>
        </div>
    )
}
